import {
    Box,
    ButtonProps,
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
} from '@mui/material'
import EditActionPanel from 'components/Form/EditActionPanel'
import React from 'react'
import AppDialogTitle from './AppDialogTitle'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import CloseDialogButton from './CloseDialogButton'

export interface ConfirmDialogProps extends DialogProps {
    allowClose?: boolean
    open: boolean

    /**
     * Dialog's title
     */
    title?: string

    /**
     * Callback function when clicked the confirmation button.
     * @returns
     */
    onSave: () => void

    /**
     * Callback function when clicked the discard button.
     * @returns
     */
    onDiscard: () => void

    /**
     * Text showing in the confirmation button.
     */
    confirmText?: string

    disabledConfirm?: boolean

    /**
     * TRUE will disabled all buttons.
     */
    disabledButton?: boolean

    children?: React.ReactNode

    /**
     * Text showing in the discard button
     */
    discardBtnText?: string
    discardColor?: ButtonProps['color']

    hideConfirmBtn?: boolean
    hideCancelBtn?: boolean
    confirmColor?: ButtonProps['color']
    isSubmitType?: boolean
}

export default function ConfirmDialog({
    open,
    title = 'Confirmation',
    children,
    onSave,
    onDiscard,
    confirmText,
    disabledConfirm,
    disabledButton,
    discardBtnText,
    discardColor,
    hideConfirmBtn,
    hideCancelBtn,
    confirmColor,
    isSubmitType,
    fullScreen,
    allowClose,
    ...other
}: ConfirmDialogProps) {
    const { isMobile } = useScreenSize()
    if (!open) return <></>
    return (
        <Dialog
            open={open}
            onClose={allowClose ? onDiscard : () => {}}
            fullScreen={fullScreen}
            {...other}
        >
            {title && <AppDialogTitle text={title} />}
            {allowClose && (
                <CloseDialogButton
                    dialogName="confirm dialog"
                    onClick={onDiscard}
                />
            )}
            <DialogContent sx={{ border: 'none' }}>
                <Box alignItems={'center'} height="100%">
                    {children}
                </Box>
            </DialogContent>

            <DialogActions>
                <Box p={isMobile ? 0 : 2} pt={0} width={'100%'}>
                    <EditActionPanel
                        onSave={onSave}
                        onDiscard={onDiscard}
                        disabled={disabledButton}
                        saveDisabled={disabledConfirm}
                        saveText={confirmText}
                        discardText={discardBtnText}
                        hideConfirmBtn={hideConfirmBtn}
                        hideDiscardBtn={hideCancelBtn}
                        saveColor={confirmColor}
                        discardColor={discardColor}
                        isSubmitType={isSubmitType}
                        fullButtons={fullScreen}
                        buttonHeight={fullScreen ? 60 : undefined}
                    />
                </Box>
            </DialogActions>
        </Dialog>
    )
}
